import React, { useEffect } from "react";
import {
  Button, TextField, Grid,
  makeStyles, Typography
} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import ForgetForm from "./ForgetForm";
import { putPwReset } from '../../api/helpline/account'


const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    "& input::-ms-clear, & input::-ms-reveal": {// Edge,IE clear button(x) hidden
      display: 'none'
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 1),
    width: "100%",
    maxWidth: '250px'
  },
}));

interface Props {
  form: {
    userId: string
    password: string
  },
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  errorMsg: string,
  onSubmit: (event: any) => void,
  handleError: (err: any) => void,
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void
}

const LoginForm: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { form, handleChangeForm, errorMsg, onSubmit, handleError, handleNotificationOpen } = props
  const [open, setOpen] = React.useState(false)
  const [forgetForm, setForgetForm] = React.useState({
    companyName: '',
    name: '',
    userId: ''
  })
  const [reqItem, setReqItem] = React.useState({
    companyName: true,
    name: true,
    userId: true,
  })
  const handleChangeForgetForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    setForgetForm({
      ...forgetForm,
      [event.target.name as string]: event.target.value as string
    })
  }
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let cleanup = false
    if (!cleanup) {
      setReqItem({
        ...reqItem,
        companyName: forgetForm.companyName ? false : true,
        name: forgetForm.name ? false : true,
        userId: forgetForm.userId ? false : true
      })
    }
    return () => { cleanup = true }
  }, [forgetForm])

  const forgetSubmit = () => {
    putPwReset(forgetForm).then(res => {
      setOpen(false);
      handleNotificationOpen('success', 'パスワードリセット依頼')
    }).catch(err => { setOpen(false); handleError(err) })
  }

  useEffect(() => {
    let cleanup = false
    if (!cleanup && open) {
      setForgetForm({
        ...forgetForm,
        companyName: '',
        name: '',
        userId: ''
      })
    }
    return () => { cleanup = true }
  }, [open])

  const check = form.userId.length * form.password.length === 0 ? true : false

  return (
    <div>
      <form className={classes.form} noValidate onSubmit={onSubmit} style={{ textAlign: "center" }}>
        <Grid container spacing={1} alignItems="flex-end" justify="center">
          <Grid item>
            <AccountCircle />
          </Grid>
          <Grid item>
            <TextField id="userId" name="userId" label="ユーザー名" autoComplete='username' autoFocus onChange={handleChangeForm} />
          </Grid>
        </Grid>
        <Grid container spacing={1} alignItems="flex-end" justify="center">
          <Grid item>
            <VpnKeyIcon />
          </Grid>
          <Grid item>
            <TextField id="password" label="パスワード" name="password" type="password" autoComplete="current-password" onChange={handleChangeForm} />
          </Grid>
        </Grid>
        <Grid container alignItems="flex-end" justify="center">
          <Grid item xs={8}>
            {errorMsg && (<Typography color="error" variant="caption">{errorMsg}</Typography>)}
          </Grid>
          <Button type="submit" variant="contained" color="primary" disabled={check} className={classes.submit} onClick={onSubmit}>ログイン
        </Button>
          <Grid container justify='flex-end'>
            <Grid xs={8}>
              <Button color="primary" size='small' onClick={handleClickOpen}>パスワードをお忘れですか?</Button>
            </Grid>
            <ForgetForm open={open} handleClose={handleClose} handleChangeForgetForm={handleChangeForgetForm} forgetSubmit={forgetSubmit} reqItem={reqItem} />
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
export default LoginForm;
